module.exports = __webpack_public_path__ + "img/link.65111a1c.png";